/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBoxMultiple9 = createReactComponent("box-multiple-9", "IconBoxMultiple9", [
  [
    "path",
    {
      d: "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M14 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-1" }],
  ["path", { d: "M12 12a2 2 0 1 0 4 0v-4", key: "svg-2" }],
  [
    "path",
    {
      d: "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2",
      key: "svg-3"
    }
  ]
]);

export { IconBoxMultiple9 as default };
//# sourceMappingURL=IconBoxMultiple9.js.map
